import createContext from 'contexts/create-context';
import * as React from 'react';
import useSWR from 'swr';

import { getCarrierPortalCarrierInfo, CarrierPortalCarrierInfo } from './models';
import { SpinnerBlock } from 'components/Spinner';
import { useTranslation } from 'contexts/translation-context';
import { ErrorState } from 'components/error-state/ErrorState';

export type Supplier = CarrierPortalCarrierInfo;

interface ProviderValue {
  supplier: Supplier;
  carrierId: number;
  refreshData: () => void;
}

const [useContext, ReactProvider] = createContext<ProviderValue>();

interface ICarrierPortalCarrierProviderProps {
  carrierId: number;
  children?: React.ReactNode;
}

export const CarrierPortalCarrierProvider: React.FC<ICarrierPortalCarrierProviderProps> = (props) => {
  const { children, carrierId } = props;
  const { i18n } = useTranslation();

  const {
    data: supplier,
    error,
    mutate,
  } = useSWR(`carrier-portal-carrier-info-${carrierId}`, () => getCarrierPortalCarrierInfo(carrierId));

  if (error) {
    return <ErrorState error={error} onRetry={() => mutate()} variant="page" />;
  }

  if (!supplier) {
    return <SpinnerBlock message={i18n('carrierPortal.loading')} />;
  }

  return <ReactProvider value={{ supplier, carrierId, refreshData: mutate }}>{children}</ReactProvider>;
};

export const useCarrierPortalSupplier = useContext;
